<template>
  <div class="teamsite" v-if="teamsiteConfig">
    <admin-edit title="ECP bearbeiten" :url="`/pl/0/platform_admin/team_site_configurations/${teamsiteConfig.id}/edit`"></admin-edit>
    <teamsite-hero v-if="hero && hero.image" :imageUrl="hero.image.url" :learnMore="$t('teamsite.learn_more.link')" scrollTo="#more-info">

      <template slot="campaign-badge">
        <sign-up-campaign-badge :info="signUpCampaignInfo"></sign-up-campaign-badge>
      </template>

      <template slot="heading">
        {{ hero.title }}
      </template>

      <template slot="paragraph">
        <div class="columns small-22 small-offset-1">
          {{ hero.subtitle }}
        </div>
      </template>

    </teamsite-hero>

    <more-info :intro="intro" id="more-info"></more-info>

    <animation-content-swiper class="how-it-works"
                              :title="$t('teamsite.how_it_works.title')"
                              :slides="howItWorksSlides"
                              :animationData="animationData"
                              :animationSegments="[{ frames: [0, 14] },
                                                   { frames: [24, 34] },
                                                   { frames: [48, 58] },
                                                   { frames: [72, 93] },
                                                   { from: 1, to: 3, frames: [96, 105] },
                                                   { from: 1, to: 4, frames: [144, 160] },
                                                   { from: 2, to: 4, frames: [120, 136] }]" />

    <cars-preview v-if="cars" :cars="cars"/>

    <content-swiper :slides="benefitsSlides" :title="$t('teamsite.benefits.title')"></content-swiper>

    <divider :size="10"/>

    <giant-cta>
      <template slot="post-cta-section" v-if="signUpCampaignDiscaimer">
        <div id="campaign-info"></div>
        <div class="campaign-info-content">
          <p v-html="signUpCampaignDiscaimer" class="row column small-21 medium-22 small-centered"></p>
        </div>
      </template>
    </giant-cta>

  </div>
</template>

<script>
const howItWorksMoqoAnimationData = require('@/assets/animations/how_it_works.json')
const howItWorksPlusAnimationData = require('@/assets/animations/how_it_works_plus.json')

export default {
  name: 'Teamsite',

  computed: {
    hero() {
      return this.teamsiteConfig && this.teamsiteConfig.hero
    },

    signUpCampaignInfo () {
      if (!this.teamsiteConfig.signup_campaign_advertisement_value) return null

      return this.$t('teamsite.sign_up_campaign.badge', {
        campaign_value: this.teamsiteConfig.signup_campaign_advertisement_value.formatted,
        disclaimer_link: "<a href='#campaign-info'>*</a>"
      })
    },

    signUpCampaignDiscaimer () {
      if (!this.teamsiteConfig.signup_campaign_advertisement_value) return null

      return '<sup>*</sup>' + this.teamsiteConfig.signup_campaign_advertisement_disclaimer
    },

    intro() {
      return this.teamsiteConfig && this.teamsiteConfig.intro
    },

    cars () {
      if (!(this.teamsiteConfig && this.teamsiteConfig.cars)) { return null }
      return this.teamsiteConfig.cars.slice(0, 2)
    },

    carImage () {
      if (this.teamsiteConfig.intro && this.teamsiteConfig.intro.car_image) {
        return this.teamsiteConfig.intro.car_image.url
      }
    },

    animationData () {
      let animationData = howItWorksMoqoAnimationData
      if (this.teamsiteConfig.team_context === 'plus') animationData = howItWorksPlusAnimationData

      // Assume first image is car image
      const carImage = animationData.assets[0]
      if (carImage && !carImage.e) {
        carImage.e = true
        carImage.p = this.carImage || require('@/assets/icons/fallback_car.png')
      }

      return animationData
    },

    howItWorksSlides () {
      let slides = [
        this.$t(`teamsite.how_it_works_slide_1${this.vehicleString('', '_bike')}`),
        this.$t(`teamsite.how_it_works_slide_2${this.vehicleString('', '_bike')}`),
        this.$t('teamsite.how_it_works_slide_3'),
        this.$t(`teamsite.how_it_works_slide_4${this.vehicleString('', '_bike')}`)
      ].map(slide => Object.assign({}, slide))

      if (this.teamsiteConfig.external_drivers_license_check || this.isBikeOnly) {
        slides.splice(2,1)
      }else {
        if(this.teamsiteConfig.digital_drivers_license_check)
          slides[2].text += this.$t('teamsite.how_it_works_slide_3.text_with_postid')
        else
          slides[2].text += this.$t('teamsite.how_it_works_slide_3.text_without_postid')
      }
      return slides
    },

    benefitsSlides () {
      let slides = [
        this.$t(`teamsite.benefits_slide_1${this.vehicleString('', '_bike')}`),
        this.$t('teamsite.benefits_slide_2'),
        this.$t(`teamsite.benefits_slide_3${this.vehicleString('', '_bike')}`),
        this.$t(`teamsite.benefits_slide_4${this.vehicleString('', '_bike')}`)
      ]

      if (this.isFreeForAll) {
        slides.splice(1, 1)
      }

      return slides
    }
  }
}
</script>

<style lang="scss">
  .sign_up_campaign {
    float: right;
    margin-top: rem-calc(150);

    sup {
      top: -.25em
    }

    a {
      font-size: rem-calc(18);
      font-weight: inherit;
      color: inherit;
    }

    @include breakpoint(small only) {
      float: none;
      overflow: hidden;
      margin-top: 15vh;
      margin-left: auto;
      margin-right: auto;
    }
  }

  #campaign-info {
    position: relative;
    top: -160px;
  }

  .campaign-info-content {
    margin-top: -60px;
    padding-bottom: 30px;
    background-color: $very-light-gray;

    p {
      font-size: rem-calc(13);
      text-align: center;
      max-width: rem-calc(890);
    }

    sup {
      top: -.25em;
      font-size: rem-calc(18);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Teamsite.vue